import React from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

const CategoryCount = ({ data }) => {
  const baseUrl = `${import.meta.env.VITE_IP}/close`;

  const close = async (endpoint) => {
    let url = endpoint === 'Año' ? 'Ano' : endpoint;
    
    // Only ask for user code when closing the day
    if (endpoint === 'Dia') {
      const { value: userCode } = await Swal.fire({
        title: 'Ingrese su código de usuario',
        input: 'password',
        inputPlaceholder: 'Código',
        inputAttributes: {
          autocapitalize: 'off',
          autocorrect: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showLoaderOnConfirm: true,
        preConfirm: (code) => {
          return new Promise((resolve, reject) => {
            const users = {
              '960116': 'Daniel',
              '970603': 'Alejandra',
              '091020': 'Valery',
              '061031': 'Anghely'
            };
            
            if (users[code]) {
              resolve({ code, name: users[code] });
            } else {
              reject('Código incorrecto');
            }
          });
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      if (userCode) {
        // Send the user information along with the close request
        await axios.post(`${baseUrl}${url}`, { 
          user: userCode.name,
          code: userCode.code,
          timestamp: new Date().toISOString()
        }).then((json) => {
          console.log(json);
          Swal.fire({
            title: 'Día cerrado',
            text: `El día ha sido cerrado por ${userCode.name}`,
            icon: 'success'
          });
        }).catch(err => {
          console.error(err);
          Swal.fire({
            title: 'Error',
            text: 'Hubo un problema al cerrar el día',
            icon: 'error'
          });
        });
      }
    } else {
      // For other endpoints (month, year), keep the original behavior
      await axios.post(baseUrl + url).then((json) => console.log(json));
    }
  };

  const handleButtonClick = async (endpoint) => {
    const { value: password } = await Swal.fire({
      title: 'Ingrese la contraseña',
      input: 'password',
      inputPlaceholder: 'Contraseña',
      inputAttributes: {
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: (inputPassword) => {
        return new Promise((resolve, reject) => {
          if (inputPassword === '212413ad') {
            resolve();
          } else {
            reject('Contraseña incorrecta');
          }
        });
      },
      allowOutsideClick: () => !Swal.isLoading()
    });

    if (password) {
      // Contraseña correcta
      if (endpoint === 'day') {
        window.location.href = '/cuentas/day';
      } else if (endpoint === 'month') {
        window.location.href = '/cuentas/month';
      } else if (endpoint === 'year') {
        window.location.href = '/cuentas/year';
      } else if (endpoint === 'closings') {
        window.location.href = '/cuentas/closings';
      }
    }
  };

  return (
    <div>
      <div className="countoptions">
        {data === 'year' ? (
          <></>
        ) : (
          <button id="close" className="btn btn-danger" onClick={() => close(data)}>
            Cerrar el {data}
          </button>
        )}
      </div>
      <div className="countManager">
        <button className="btn btn-info" onClick={() => handleButtonClick('day')}>
          Dias
        </button>
        <button className="btn btn-warning" onClick={() => handleButtonClick('month')}>
          Meses
        </button>
        <button className="btn btn-success" onClick={() => handleButtonClick('year')}>
          Años
        </button>
        <button className="btn btn-primary" onClick={() => handleButtonClick('closings')}>
          Registros de Cierre
        </button>
      </div>
    </div>
  );
};

export default CategoryCount;
